import { validateNotBlank } from 'simple-valley'

export default function ugcCaptionValidator(v) {
  if (!v.data.caption) return v

  return validateNotBlank(v, 'assetId', { message: 'Please provide an asset' })
}
